module.exports = __webpack_public_path__ + "qr_code_android_plp.0179dc3.png";